// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__bkb38","description":"NotFoundBlock_description__FstIM"};